<template>
    <main-content>
        <gateway-form
                v-if="status === 'successShop' && active_psp === 'loaded'"
                :submit="update"
                :form_data="form_data"
                :psp="psp"
                :port_config="port_config"
        ></gateway-form>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import $ from "jquery";
import {collectiveService, dedicatedService} from '@/common/api.service'
import {KTApp} from '@/plugins/core/app'
import {mapGetters} from 'vuex'
import {gatewayForm} from './components'

export default {
    components: {
        'main-content': mainContent,
        'gateway-form': gatewayForm,
    },
    computed: {
        ...mapGetters('collective', ['form_data', 'status', "psp", "active_psp"]),
    },
    mounted() {
        this.$store.dispatch('collective/getActivePsp').finally(() => {
            this.$store.dispatch('collective/findGate', this.hashid)
        })

        // this.port_config = this.form_data.port_config;
    },
    methods: {
        update() {
            let form = $('#gateway_form')
            let btn = $('#submit_btn')

            KTApp.progress(btn)
            if (typeof this.form_data.port_config === 'object') {
                this.form_data.port_config = JSON.stringify(this.form_data.port_config);
            }


            dedicatedService.updateShopCategories({shop_category_ids: this.form_data.shop_category_ids} , this.hashid).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            collectiveService.updateGate(this.hashid, this.form_data).then(response => {
            }).catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                       this.$router.push('/collective')
                        KTApp.unprogress(btn)
                    })
        },

    },
    data() {
        return {
            hashid: this.$route.params.hashid,
            port_config: {}
        }
    },
}
</script>

<style>

</style>